import React from "react";

export default class AgTableSerialNumber extends React.Component {
  render() {
    return <span>{this.props.rowIndex + 1}</span>;
  }
}
